<template>
  <div>
    <template v-if="showIcon">
      <p class="icon-text-heading">{{ ellipsize(selectedTextHeading) }}</p>
    </template>
    <template v-else>
      <p class="icon-text-heading">{{ ellipsize(textHeading) }}</p>
    </template>
    <p class="icon-text-sub-heading" v-if="showIcon">{{ ellipsize(textSubHeading) }}</p>
    <AppIcon class="icon-text" name="check-circle-o" scale="1.2" v-if="showIcon"></AppIcon>
  </div>
</template>

<script>
import AppIcon from '@/components/AppIcon.vue';
export default {
  props: {
    showIcon: {
      type: Boolean,
      default: false
    },
    textHeading: {
      type: String,
      default: ''
    },
    selectedTextHeading: {
      type: String,
      default: ''
    },
    textSubHeading: {
      type: String,
      default: ''
    }
  },
  components: {
    AppIcon
  },
  methods: {
    ellipsize (text) {
      const value = text || '';
      const max = 60;
      if (value.length <= max) {
        return value;
      }
      return value.substring(0, max + 1) + '...';
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .icon-text-heading {
    font-weight: bold;
  }

  .icon-text-heading,
  .icon-text-sub-heading {
    margin: 0;
  }

  .icon-text {
    position: absolute;
    right: 25px;
    top: 25px;
    color: #28a745;
  }
</style>
